module.exports = "https://assets.sidelineswap.com/web/_next/static/videos/7-db487753e0a85dd0d30b7f7b29a5af0c.webm";